"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showRGBA;
/**
 * @name show_rgba
 * @description // make a given (scaled) rgba value visible
 * @param {RGBA} rgba pixel
 * @returns a new rgba pixel with the same Red, Green and Blue values and a 255 alpha value
 */
function showRGBA([r, g, b]) {
  return [r, g, b, 255];
}